import React, { useState, useEffect } from "react";
import { 
  Container, Typography, Card, CardContent, List, 
  ListItem, ListItemText, Button, Box, CircularProgress 
} from "@mui/material";
import { getUserTeams } from "../../api/api"; // API call

const Teams = () => {
  const [loading, setLoading] = useState(true);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const userTeams = await getUserTeams();
        setTeams(userTeams);
      } catch (error) {
        console.error("Error fetching teams:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  const handleCreateTeam = () => {
    console.log("Redirect to team creation form...");
    // Future: Navigate to create team page or show modal
  };

  if (loading) {
    return (
      <Container sx={{ textAlign: "center", mt: 4 }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 4 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Your Teams</Typography>
        <Button variant="contained" color="primary" onClick={handleCreateTeam}>
          Make Team
        </Button>
      </Box>

      {teams.length > 0 ? (
        <List>
          {teams.map((team) => (
            <Card key={team.id} sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="h6">{team.name}</Typography>
                <Typography variant="body2">
                  <strong>Access Level:</strong> {team.role}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </List>
      ) : (
        <Typography variant="body2">You are not part of any teams.</Typography>
      )}
    </Container>
  );
};

export default Teams;
